/* eslint-disable react/jsx-key */
// Station
import React, { useState } from 'react'
import { strCol } from '@integec/grid-tools/lib/cols'
import { modifierCol, modifiedDateCol } from 'core/HeaderColTypeProps'
import {
  deleteSolarStorageInverterManufacturer,
  getSolarStorageInverterManufacturer,
  updateSolarStorageInverterManufacturer,
} from 'api/pgads.js'

import { Input, Button } from 'antd'
import CommonScreen from 'admin/component/CommonScreen'
import { Label } from 'core/screen-util'

const headers = [
  strCol({
    ident: 'manufacturerCode',
    display: 'Manufacturer Code',
    isKey: true,
    width: 150,
    sortOrder: 'asc',
  }),
  strCol({
    ident: 'manufacturerName',
    display: 'Manufacturer Name',
    isFiltered: true,
    isRequired: true,
    width: 300,
    sortOrder: 'asc',
  }),
  modifierCol,
  modifiedDateCol,
]

const title = 'Solar Storage Inverter Manufacturer'

const SolarStorageInverterManufacturer = _ => {
  const [insertEvent, setInsertEvent] = useState(false)

  const insertComp = ({ insertData, setInsertData, onAdd, onCancel }) => {
    return (
      <>
        <div
          style={{
            display: 'grid',
            gridTemplateColumns: '140px 250px 140px 250px',
            gap: 10,
          }}
        >
          <div>
            <Label style={{ display: 'inline', float: 'right' }}>
              Manufacturer Code :
            </Label>
            <span style={{ color: 'red', marginRight: '2px', float: 'right' }}>
              *
            </span>
          </div>
          <td style={{ minWidth: '100px' }}>
            <Input
              maxLength={5}
              key="manufacturerCode"
              value={insertData.manufacturerCode}
              placeholder="Manufacturer Code"
              name="manufacturerCode"
              onChange={e =>
                setInsertData({
                  ...insertData,
                  manufacturerCode: e.target.value,
                })
              }
            />
          </td>
          <div>
            <Label style={{ display: 'inline', float: 'right' }}>
              Manufacturer Name :
            </Label>
            <span style={{ color: 'red', marginRight: '2px', float: 'right' }}>
              *
            </span>
          </div>
          <Input
            key="manufacturerName"
            value={insertData.manufacturerName}
            placeholder="Manufacturer Name"
            name="manufacturerName"
            onChange={e =>
              setInsertData({
                ...insertData,
                manufacturerName: e.target.value,
              })
            }
          />
          <div
            style={{
              display: 'grid',
              gridTemplateColumns: '1fr 1fr 1fr',
              gap: 5,
              gridColumnStart: '3',
              gridColumnEnd: 'span 2',
            }}
          >
            <Button type="primary" onClick={() => onAdd(true)}>
              Add
            </Button>
            <Button type="primary" onClick={() => onAdd(false)}>
              Add & Hide
            </Button>
            <Button type="danger" onClick={onCancel}>
              Cancel
            </Button>
          </div>
        </div>
      </>
    )
  }

  return [
    <CommonScreen
      title={title}
      header={headers}
      saveTask={updateSolarStorageInverterManufacturer}
      retrieveTask={getSolarStorageInverterManufacturer}
      deleteTask={deleteSolarStorageInverterManufacturer}
      altBy={d => d.manufacturerCode}
      autoRetrieve
      // sortOptions={[{ ident: 'stationName', display: 'Station Name', sortOrder: 'asc' }]}
      widthOffset={400}
      insertComp={insertEvent && insertComp}
      insertCompHeight={90}
      onInsertEvent={b => setInsertEvent(b)}
      sortOptions={headers}
    />,
  ]
}

export default SolarStorageInverterManufacturer
